import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { treeTopPieces } from '../utils/mapOverlay';

// Fading the layer rather than each top means overlapping tops stay at this one strength.
const TREE_TOP_OPACITY = 0.3;

// Tree tops over a layered map's tokens and under its fog, so fog still hides them and clicks reach the tokens beneath.
// Built from the map's saved layout. Maps with no painted-ground signature have their trees in the picture already.
const MapCanopy = ({ map, catalog }) => {
  const layered = Boolean(map?.groundSignature);
  const layout = map?.layout;
  const pieces = useMemo(() => (layered ? treeTopPieces(layout, catalog) : []), [layered, layout, catalog]);
  if (!pieces.length) return null;
  const style = { opacity: TREE_TOP_OPACITY, ...(layout.lighting === 'night' ? { filter: 'brightness(0.45)' } : {}) };
  return (
    <div className="campaign-map-board__canopy" style={style} aria-hidden="true">
      {pieces.map(({ key, url, left, top, width, height, turn, flip }) => (
        <img
          key={key}
          src={url}
          alt=""
          className="campaign-map-board__canopy-top"
          style={{ left: `${left}%`, top: `${top}%`, width: `${width}%`, height: `${height}%`,
            transform: `translate(-50%, -50%) rotate(${turn}deg)${flip ? ' scaleX(-1)' : ''}` }}
        />
      ))}
    </div>
  );
};

MapCanopy.propTypes = {
  map: PropTypes.shape({ layout: PropTypes.object, groundSignature: PropTypes.string }),
  catalog: PropTypes.object,
};

export default MapCanopy;
